// "Copy" buttons next to checksums.

export function initCopy(): void {
  document.querySelectorAll<HTMLButtonElement>("[data-copy]").forEach((btn) => {
    const source = btn.parentElement?.querySelector<HTMLElement>("[data-copy-source]");
    const label = btn.querySelector<HTMLElement>("[data-copy-label]");
    if (!source) return;
    btn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(source.textContent?.trim() ?? "");
        flash("Copied");
      } catch {
        // Clipboard unavailable (e.g. insecure context): select the text instead.
        const range = document.createRange();
        range.selectNodeContents(source);
        const sel = getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
        flash("Selected");
      }
    });

    let timer = 0;
    function flash(text: string) {
      if (!label) return;
      label.textContent = text;
      btn.classList.add("is-done");
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        label.textContent = "Copy";
        btn.classList.remove("is-done");
      }, 1600);
    }
  });
}
